// Assign Processes to Supervisor Constants
export const ASSIGN_PROCESSES_TO_SUPERVISOR_REQUEST = 'ASSIGN_PROCESSES_TO_SUPERVISOR_REQUEST'
export const ASSIGN_PROCESSES_TO_SUPERVISOR_SUCCESS = 'ASSIGN_PROCESSES_TO_SUPERVISOR_SUCCESS'
export const ASSIGN_PROCESSES_TO_SUPERVISOR_FAIL = 'ASSIGN_PROCESSES_TO_SUPERVISOR_FAIL'
export const ASSIGN_PROCESSES_TO_SUPERVISOR_RESET = 'ASSIGN_PROCESSES_TO_SUPERVISOR_RESET'

// Get Supervisor Process Assignments Constants
export const GET_SUPERVISOR_PROCESS_ASSIGNMENTS_REQUEST = 'GET_SUPERVISOR_PROCESS_ASSIGNMENTS_REQUEST'
export const GET_SUPERVISOR_PROCESS_ASSIGNMENTS_SUCCESS = 'GET_SUPERVISOR_PROCESS_ASSIGNMENTS_SUCCESS'
export const GET_SUPERVISOR_PROCESS_ASSIGNMENTS_FAIL = 'GET_SUPERVISOR_PROCESS_ASSIGNMENTS_FAIL'
export const GET_SUPERVISOR_PROCESS_ASSIGNMENTS_RESET = 'GET_SUPERVISOR_PROCESS_ASSIGNMENTS_RESET'

// Update Supervisor Process Assignment Constants
export const UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST = 'UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST'
export const UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS = 'UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS'
export const UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL = 'UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL'
export const UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET = 'UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET'

// Delete Supervisor Process Assignment Constants
export const DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST = 'DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST'
export const DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS = 'DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS'
export const DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL = 'DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL'
export const DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET = 'DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET'